import { ReactNode } from "react";
import Styles from "./StatusBadge.module.css";

export type StatusKind = "pending" | "successful" | "failed" | "skipped";

interface StatusBadgeProps
{
    status: StatusKind;
    label?: string;
}

export function StatusBadge({ status, label }: StatusBadgeProps): ReactNode
{
    let cls =
        status === "successful" ? Styles.successful :
            status === "failed" ? Styles.failed :
                status === "skipped" ? Styles.skipped :
                    Styles.pending;
    return (
        <span className={`${Styles.badge} ${cls}`}>
            <span className={Styles.dot} />
            {label ?? status}
        </span>
    );
}

interface StatusCountProps
{
    count: number;
    label: string;
    status: StatusKind;
}

export function StatusCount({ count, label, status }: StatusCountProps): ReactNode
{
    let cls =
        status === "successful" ? Styles.count_successful :
            status === "failed" ? Styles.count_failed :
                status === "skipped" ? Styles.count_skipped :
                    Styles.count_pending;
    return (
        <span className={`${Styles.count} ${cls}`}>{count} {label}</span>
    );
}